import {VGRollup} from "vgrollup";
import {onReady} from "../../../../modules/vegas/js/util";

function initRollup() {
	[... document.querySelectorAll('[data-rollup-content]')].forEach((element) => {
		let target = element.id,
			content = element.dataset.rollupContent || 'text';

		new VGRollup(target, {
			content: content,
			buttonText: {
				more: "Читать все...",
				less: "Свернуть"
			}
		});
	});
}

onReady(initRollup);
typeof onTurboRender !== 'undefined' && onTurboRender(initRollup);
